import { useEffect, useCallback } from 'react'
import ReactDOM from 'react-dom'
import { useTranslation } from 'react-i18next';
import '../style/Modal.css'

export default function Modal({ children, title = '', hideCloseButton = false }) {
    const { t } = useTranslation();

    const resetScroll = useCallback(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const inputs = document.querySelectorAll('.modal-content input, .modal-content textarea');
        inputs.forEach(el => el.addEventListener('blur', resetScroll));
        return () => {
            inputs.forEach(el => el.removeEventListener('blur', resetScroll));
        };
    });
    const onClose = () => {
        document.dispatchEvent(new CustomEvent('closeModal'));
    }

    const handleBackdropClick = (e) => {
        if (e.target.classList.contains('modal-backdrop')) {
            onClose();
        }
    };

    return ReactDOM.createPortal(
        <div className="modal-backdrop hard" onClick={handleBackdropClick}>
            <div className="modal-content fade-in">
                <div className="d-flex justify-content-between">
                    {title ? <h1 className='modal-pill disabled mb-2'>{title}</h1> : <div></div>}
                    <div className='align-self-end'>
                        {hideCloseButton ? null : <button className="modal-pill mb-2" onClick={onClose}>
                            {t('common.close')}
                        </button>}
                    </div>
                </div>
                {children}
            </div>
        </div>,
        document.getElementById('modal-root')
    );
}